export default function getAllProperties(object) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var testFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var proto = Object.getPrototypeOf(object);

  if (proto === Object.prototype) {
    return props;
  }

  var foundProps = Object.getOwnPropertyNames(proto);

  if (typeof testFn === 'function') {
    foundProps = foundProps.filter(name => testFn(name, proto));
  }

  foundProps = foundProps.map(name => [name, proto]).reduce((acc, val) => [...acc, val], props);
  return getAllProperties(proto, foundProps, testFn);
}